import React, { Component } from 'react';

class CfdiNotaDeCredito3 extends Component {
    render() {
        return (
            <div>
               <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                            <div className="card-header">
                                <h3 className="card-title">Consulta de CFDI's Nota de Crédito</h3>
                            </div>
                            <div className="col-md-12">
                                <div id="example1_filter" className="dataTables_filter">
                                    <label>
                                        <input type="search" className="form-control form-control-sm" placeholder="Buscar" aria-controls="example1" />
                                    </label>
                                </div>
                            </div>
                            <div className="card-body">
                                <table id="example1" className="table table-bordered table-striped">
                                <thead>
                                    <tr>
                                    <th></th>
                                    <th>Folio</th>
                                    <th>Fecha</th>
                                    <th>Cliente</th>
                                    <th>Bruto</th>
                                    <th>I.V.A</th>
                                    <th>Desc.</th>
                                    <th>Total</th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                    <td></td>
                                    <td>100</td>
                                    <td>2019-12-10
                                    </td>
                                    <td>EMPRESA DE TRANSPORTES SA DE CV</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0</td>
                                       <td><img src="dist/img/cfdi.gif" width="20"/></td>
                                        <td><img src="dist/img/pdf.gif" width="20"/></td>
                                        <td><img src="dist/img/email.png" width="20"/></td>
                                        <td><img src="dist/img/anular.gif" width="20"/></td>
                                    </tr>
                                    <tr>
                                    <td></td>
                                    <td>100</td>
                                    <td>2019-12-10</td>
                                    <td>EMPRESA DE TRANSPORTES SA DE CV</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0</td>
                                       <td><img src="dist/img/cfdi.gif" width="20"/></td>
                                        <td><img src="dist/img/pdf.gif" width="20"/></td>
                                        <td><img src="dist/img/email.png" width="20"/></td>
                                        <td><img src="dist/img/anular.gif" width="20"/></td>
                                    </tr>
                                    <tr>
                                    <td></td>
                                    <td>100</td>
                                    <td>2019-12-10</td>
                                    <td>EMPRESA DE TRANSPORTES SA DE CV</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0</td>
                                       <td><img src="dist/img/cfdi.gif" width="20"/></td>
                                        <td><img src="dist/img/pdf.gif" width="20"/></td>
                                        <td><img src="dist/img/email.png" width="20"/></td>
                                        <td><img src="dist/img/anular.gif" width="20"/></td>
                                    </tr>
                                    <tr>
                                    <td></td>
                                    <td>100</td>
                                    <td>2019-12-10</td>
                                    <td>EMPRESA DE TRANSPORTES SA DE CV</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0</td>
                                       <td><img src="dist/img/cfdi.gif" width="20"/></td>
                                        <td><img src="dist/img/pdf.gif" width="20"/></td>
                                        <td><img src="dist/img/email.png" width="20"/></td>
                                        <td><img src="dist/img/anular.gif" width="20"/></td>
                                    </tr>
                                    <tr>
                                    <td></td>
                                    <td>100</td>
                                    <td>2019-12-10</td>
                                    <td>EMPRESA DE TRANSPORTES SA DE CV</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0</td>
                                       <td><img src="dist/img/cfdi.gif" width="20"/></td>
                                        <td><img src="dist/img/pdf.gif" width="20"/></td>
                                        <td><img src="dist/img/email.png" width="20"/></td>
                                        <td><img src="dist/img/anular.gif" width="20"/></td>
                                    </tr>
                                    <tr>
                                    <td></td>
                                    <td>100</td>
                                    <td>2019-12-10</td>
                                    <td>EMPRESA DE TRANSPORTES SA DE CV</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0</td>
                                       <td><img src="dist/img/cfdi.gif" width="20"/></td>
                                        <td><img src="dist/img/pdf.gif" width="20"/></td>
                                        <td><img src="dist/img/email.png" width="20"/></td>
                                        <td><img src="dist/img/anular.gif" width="20"/></td>
                                    </tr>
                                    <tr>
                                    <td></td>
                                    <td>100</td>
                                    <td>2019-12-10</td>
                                    <td>EMPRESA DE TRANSPORTES SA DE CV</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0</td>
                                       <td><img src="dist/img/cfdi.gif" width="20"/></td>
                                        <td><img src="dist/img/pdf.gif" width="20"/></td>
                                        <td><img src="dist/img/email.png" width="20"/></td>
                                        <td><img src="dist/img/anular.gif" width="20"/></td>
                                    </tr>
                                    <tr>
                                    <td></td>
                                    <td>100</td>
                                    <td>2019-12-10</td>
                                    <td>EMPRESA DE TRANSPORTES SA DE CV</td>
                                    <td>0</td>
                                    <td>0</td>
                                        <td>0</td>
                                        <td>0</td>
                                        <td><img src="dist/img/cfdi.gif" width="20"/></td>
                                        <td><img src="dist/img/pdf.gif" width="20"/></td>
                                        <td><img src="dist/img/email.png" width="20"/></td>
                                        <td><img src="dist/img/anular.gif" width="20"/></td>
                                    </tr>
                                    
                                    <tr>
                                    <td></td>
                                    <td>100</td>
                                    <td>2019-12-10</td>
                                    <td>EMPRESA DE TRANSPORTES SA DE CV</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0</td>
                                       <td><img src="dist/img/cfdi.gif" width="20"/></td>
                                        <td><img src="dist/img/pdf.gif" width="20"/></td>
                                        <td><img src="dist/img/email.png" width="20"/></td>
                                        <td><img src="dist/img/anular.gif" width="20"/></td>
                                    </tr>
                                    <tr>
                                    <td></td>
                                    <td>100</td>
                                    <td>2019-12-10</td>
                                    <td>EMPRESA DE TRANSPORTES SA DE CV</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0</td>
                                       <td><img src="dist/img/cfdi.gif" width="20"/></td>
                                        <td><img src="dist/img/pdf.gif" width="20"/></td>
                                        <td><img src="dist/img/email.png" width="20"/></td>
                                        <td><img src="dist/img/anular.gif" width="20"/></td>
                                    </tr>
                                    <tr>
                                    <td></td>
                                    <td>100</td>
                                    <td>2019-12-10</td>
                                    <td>EMPRESA DE TRANSPORTES SA DE CV</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0</td>
                                       <td><img src="dist/img/cfdi.gif" width="20"/></td>
                                        <td><img src="dist/img/pdf.gif" width="20"/></td>
                                        <td><img src="dist/img/email.png" width="20"/></td>
                                        <td><img src="dist/img/anular.gif" width="20"/></td>
                                    </tr>
                                </tbody>
                                </table>
                            </div>
                            </div>
                        </div>
                    </div>
              </div>
              <div class="float-right">
                  <div class="dataTables_paginate paging_simple_numbers" id="example1_paginate">
                      <ul class="pagination">
                          <li class="paginate_button page-item previous disabled" id="example1_previous">
                              <a href="#" aria-controls="example1" data-dt-idx="0" tabindex="0" class="page-link"> <i class="fas fa-chevron-left"></i> </a></li><li class="paginate_button page-item active"><a href="#" aria-controls="example1" data-dt-idx="1" tabindex="0" class="page-link">1</a>
                            </li>
                            <li class="paginate_button page-item ">
                                <a href="#" aria-controls="example1" data-dt-idx="2" tabindex="0" class="page-link">2</a>
                            </li>
                            <li class="paginate_button page-item ">
                                <a href="#" aria-controls="example1" data-dt-idx="3" tabindex="0" class="page-link">3</a>
                                </li>
                            <li class="paginate_button page-item ">
                                <a href="#" aria-controls="example1" data-dt-idx="4" tabindex="0" class="page-link">4</a>
                            </li>
                            <li class="paginate_button page-item ">
                                <a href="#" aria-controls="example1" data-dt-idx="5" tabindex="0" class="page-link">5</a>
                            </li>
                            <li class="paginate_button page-item ">
                                <a href="#" aria-controls="example1" data-dt-idx="6" tabindex="0" class="page-link">6</a>
                            </li>
                            <li class="paginate_button page-item next" id="example1_next">
                                <a href="#" aria-controls="example1" data-dt-idx="7" tabindex="0" class="page-link"> <i class="fas fa-chevron-right"></i> </a>
                            </li>
                        </ul>
                    </div>
              </div>
            </div>
        );
    }
}

export default CfdiNotaDeCredito3;